function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef } from "react";
import { useLazyQuery } from "@apollo/client";
import { HEALTH_QUERY } from "./query";
var Maintenance = function Maintenance(_ref) {
  var history = _ref.history;
  return null;
  var redirectedRef = useRef(false);
  var _useLazyQuery = useLazyQuery(HEALTH_QUERY, {
      fetchPolicy: "network-only"
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getHealthDetails = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    healthData = _useLazyQuery2$.data,
    healthError = _useLazyQuery2$.error;

  // 🔁 Poll health
  useEffect(function () {
    getHealthDetails();
    var interval = setInterval(function () {
      getHealthDetails();
    }, 60000); // 1 min

    window.addEventListener("online", getHealthDetails);
    return function () {
      clearInterval(interval);
      window.removeEventListener("online", getHealthDetails);
    };
  }, [getHealthDetails]);

  // ✅ Redirect ONLY when backend is healthy
  useEffect(function () {
    var _healthData$health;
    if ((healthData === null || healthData === void 0 ? void 0 : (_healthData$health = healthData.health) === null || _healthData$health === void 0 ? void 0 : _healthData$health.status) === "ok" && !redirectedRef.current) {
      redirectedRef.current = true;
      history.replace("/overview");
    }
  }, [healthData, history]);

  // Optional debug
  useEffect(function () {
    if (healthError) {
      console.log("Still offline / backend down");
    }
  }, [healthError]);
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center min-vh-100 bg-light"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card shadow-lg border-0",
    style: {
      maxWidth: "820px",
      width: "100%",
      borderRadius: "12px",
      margin: "41px 0px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body p-4 text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-inline-flex align-items-center justify-content-center",
    style: {
      width: 40,
      height: 40,
      backgroundColor: "#ffc107",
      borderRadius: "12px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-weight-bold text-dark",
    style: {
      fontSize: "32px"
    }
  }, "!"))), /*#__PURE__*/React.createElement("h4", {
    className: "font-weight-bold mb-3"
  }, "Scheduled Maintenance in Progress"), /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-2"
  }, "We sincerely apologize for the inconvenience caused and appreciate your patience."), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary mb-3",
    style: {
      fontSize: "14px"
    }
  }, "We are experiencing a high usage spike during this time, which is affecting our servers. To ensure stability, the website is ", /*#__PURE__*/React.createElement("strong", null, "temporarily on hold for maintenance"), "."), /*#__PURE__*/React.createElement("div", {
    className: "row mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border rounded h-100 p-4 text-left"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-3 text-center"
  }, "For Team Members:"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start mb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-success mr-2"
  }, "\u2714"), /*#__PURE__*/React.createElement("span", null, "Your work hours will not be lost")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start mb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-success mr-2"
  }, "\u2714"), /*#__PURE__*/React.createElement("span", null, "All data is being securely recorded")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-success mr-2"
  }, "\u2714"), /*#__PURE__*/React.createElement("span", null, "Desktop app is working normally")))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border rounded h-100 p-4 text-left"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-3 text-center"
  }, "For Admins:"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start mb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary mr-2"
  }, "\uD83D\uDD52"), /*#__PURE__*/React.createElement("span", null, "Please wait before accessing dashboards")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start mb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-success mr-2"
  }, "\u2714"), /*#__PURE__*/React.createElement("span", null, "All team data is safely stored")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-success mr-2"
  }, "\u2714"), /*#__PURE__*/React.createElement("span", null, "Data will be available ~1 hour after maintenance"))))), /*#__PURE__*/React.createElement("div", {
    className: "border-top pt-3 mb-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-1"
  }, /*#__PURE__*/React.createElement("strong", null, "Estimated Duration:"), " ~ 75 minutes"), /*#__PURE__*/React.createElement("p", {
    className: "mb-1"
  }, /*#__PURE__*/React.createElement("strong", null, "Expected End Time:"), " 15:30 UTC"), /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, /*#__PURE__*/React.createElement("strong", null, "Current UTC Time:"), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-primary"
  }, "14:52:17"))), /*#__PURE__*/React.createElement("p", {
    className: "text-muted mt-3 mb-0",
    style: {
      fontSize: "14px"
    }
  }, "We are actively monitoring the situation and working on a permanent fix. We apologize again for the inconvenience."))));
};
export default Maintenance;